import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import ReactPlayer from "react-player";
import {
  saveBrand,
  saveUnreadSupportMessages,
  saveUnreadMessagesFromSuper,
  saveSuperContents,
} from "../../redux/actions";
import { SuperContentSelector } from "../../redux/reducers";
import Header from "../../components/Header";
import NewPoll from "../../components/NewPoll";
import NewOffer from "../../components/NewOffer";
import AddPost from "../Feeds/components/AddPost";
import AddCompetiton from "../Competitions/components/AddCompetition";
import AddEventModal from "../Event/AddEventModal";
import Firebase from "../../firebasehelper";
import "./index.css";
import pollsImg from "../../assets/media/analytics_icons/user_reviews.png";
import feedsImg from "../../assets/media/Topic.png";
import offerImg from "../../assets/media/percent-coin.png";
import gameImg from "../../assets/media/competition.png";
import plugImg from "../../assets/media/plus.png";
import checkImg from "../../assets/media/check.png";
import fireImg from "../../assets/media/fire.png";
import eventImg from "../../assets/media/ticket.png";

import { TerritoryOptions } from "../../Constants/retailer";
import { getYoutubeId } from "../../Utils/utils";
import { Link } from "react-router-dom";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
  GIF_UPLOAD,
} from "../../Constants/types";
const UPLOADING_VIDEO = "Uploading video";
const UPLOADING_IMAGE = "Uploading image...";
const $ = window.$;

// class SuperContentPlanner extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       username: "",
//       loading: false,
//       loading_script: "",
//       postData: null,
//       posts: [],
//       users: [],
//       polls: [],
//       events: [],
//       competitions: [],
//       retailers: [],
//       offers: [],
//       selectedWeek: 0,
//       selectedDate: null,
//       hotTopics: [],
//       current_hotTopic: null,
//     };
//   }

//   componentDidMount() {
//     if (!this.props.location.state) {
//       this.props.history.push("/");
//     } else {
//       const { brand, role, username } = this.props.location.state;
//       this.setState({ username, role, brand });
//       Firebase.getBrandDataByID(brand, async (brand_data) => {
//         brand_data.id = brand;
//         this.props.dispatch(saveBrand(brand_data));
//         this.setState(
//           {
//             logo: brand_data.logo,
//             icon: brand_data.icon,
//             brand_name: brand_data.name,
//             brand_url: brand_data.url,
//             territory: brand_data.territory || TerritoryOptions[0],
//             hex: brand_data.hex,
//             is_property_brand: brand_data.is_property_brand
//               ? brand_data.is_property_brand
//               : false,
//           },
//           () => {
//             this.setState({ polls: brand_data.polls || [] });
//             Firebase.getAllPosts(brand_data.name, this.subscribePosts);
//             Firebase.getAllCompetitions(
//               brand_data.name,
//               this.subscribeCompetitions
//             );
//             // Firebase.getAllUsersInBrand
//             Firebase.getAllBrandOffers(brand_data.name, this.subscribeOffers);
//             Firebase.getAllRetailers(this.subscribeRetailers);
//             Firebase.getAllEvents(brand_data.name, this.subscribeEvents);
//             Firebase.getAllHotTopics(brand_data.name, this.subscribeHotTopics);
//             Firebase.getUnReadMessages(
//               brand_data.name,
//               this.subscribeUnreadMessages
//             );
//             Firebase.getBrandUnReadMessages(
//               brand,
//               this.subscribeBrandUnreadMessages
//             );
//           }
//         );
//       });
//     }
//   }

//   subscribeCompetitions = (competitions) => {
//     this.setState({ competitions });
//   };

//   subscribeEvents = (events) => {
//     let Ev = events.filter((event) => event.time);
//     this.setState({ events: Ev });
//   };

//   subscribePosts = (posts) => {
//     posts.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
//     this.setState({ posts, loading: false });
//   };

//   subscribeUsers = (users) => {
//     this.setState({ users });
//   };

//   subscribeOffers = (offers) => {
//     this.setState({ offers: offers.filter((obj) => !obj.newadvent) });
//   };
//   subscribeHotTopics = (hotTopics) => {
//     this.setState({ hotTopics }, this.getHotTopic);
//   };
//   subscribeRetailers = (retailers) => {
//     this.setState({
//       retailers: Object.values(retailers).filter(
//         (obj) => (obj.territory || TerritoryOptions[0]) === this.state.territory
//       ),
//     });
//   };
//   subscribeUnreadMessages = (unreads) => {
//     this.props.dispatch(saveUnreadSupportMessages(unreads));
//   };
//   subscribeBrandUnreadMessages = (unreads) => {
//     const unreadsFromSuper = [];
//     Object.keys(unreads).map((ticket_id) => {
//       unreadsFromSuper.push({
//         id: ticket_id,
//         ...unreads[ticket_id],
//       });
//     });
//     this.props.dispatch(saveUnreadMessagesFromSuper(unreadsFromSuper));
//   };

//   showPlans = (type = "feed") => {
//     let PlanItem = ({ date }) => {
//       let image = null,
//         youtube_video = null,
//         video = null;
//       if (type === "feed") {
//         const post = this.state.posts.find((obj) =>
//           date.isSame(new Date(obj.scheduledDate), "day")
//         );
//         image =
//           post && post.media_type === IMAGE_UPLOAD ? post.media_url : null;
//         youtube_video =
//           post && post.media_type === YOUTUBE_URL ? post.media_url : null;
//         video =
//           post && post.media_type === VIDEO_UPLOAD ? post.media_url : null;
//       } else if (type === "poll") {
//         const poll = this.state.polls.find((obj) =>
//           date.isSame(new Date(obj.scheduledDate), "day")
//         );
//         image = poll ? poll.question_img : null;
//       } else if (type === "competition") {
//         const competition = this.state.competitions.find((obj) =>
//           date.isSame(new Date(obj.scheduledDate), "day")
//         );
//         image = competition ? competition.img_url : null;
//       } else if (type === "offer") {
//         const offer = this.state.offers.find((obj) =>
//           date.isSame(new Date(obj.scheduledDate), "day")
//         );
//         const retailer = this.state.retailers.find(
//           (obj) => offer && obj.retailerName === offer.retailer
//         );
//         image = retailer ? retailer.logo : null;
//       } else if (type === "event") {
//         const event = this.state.events.find((obj) =>
//           date.isSame(obj.time.toDate(), "day")
//         );
//         image = event ? event.image_url : null;
//       }
//       if (image) {
//         return (
//           <div
//             style={{ backgroundImage: `url(${image})` }}
//             className="calendar-item"
//           >
//             <img className="checkmark" src={checkImg} alt="checkmark" />
//           </div>
//         );
//       }
//       if (video) {
//         return (
//           <div className="calendar-item">
//             <ReactPlayer
//               url={video}
//               width="100%"
//               height="100%"
//               controls={true}
//             />
//             <img className="checkmark" src={checkImg} alt="checkmark" />
//           </div>
//         );
//       }
//       if (youtube_video) {
//         return (
//           <div className="calendar-item">
//             <iframe
//               title="video"
//               width="100%"
//               height="100%"
//               src={`//www.youtube.com/embed/${getYoutubeId(
//                 youtube_video
//               )}?modestbranding=1&showinfo=0`}
//               frameBorder="0"
//               allowFullScreen
//             ></iframe>
//             <img className="checkmark" src={checkImg} alt="checkmark" />
//           </div>
//         );
//       }
//       const isPastDay = date.isBefore(moment(), "day");
//       return (
//         <button
//           className="add-plan-btn"
//           type="button"
//           data-toggle="modal"
//           data-target={`#add_${type}_modal`}
//           onClick={() => {
//             this.setState({ selectedDate: date });
//           }}
//           disabled={isPastDay}
//         >
//           {!isPastDay && (
//             <img src={plugImg} className="default-item" alt="default" />
//           )}
//         </button>
//       );
//     };

//     return [0, 1, 2, 3, 4, 5, 6].map((i) => (
//       <div key={i} className="plan">
//         <PlanItem date={this.getWeekDate(i)} />
//       </div>
//     ));
//   };

//   getWeekDate = (i) => {
//     if (moment().isSame(moment().startOf("week"))) {
//       return moment().add("days", this.state.selectedWeek * 7 + i - 6);
//     }
//     return moment()
//       .startOf("week")
//       .add("days", this.state.selectedWeek * 7 + i + 1);
//   };
//   getHotTopic = () => {
//     const { hotTopics } = this.state;
//     const week_start = this.getWeekDate(0);
//     let matched_hotTopic = hotTopics.find((hotTopic) => {
//       const hotTopic_date = hotTopic.starting_monday.toDate();
//       if (week_start.isSame(hotTopic_date, "day")) {
//         return true;
//       }
//     });
//     this.setState({ current_hotTopic: matched_hotTopic });
//   };
//   showDays = () => {
//     const weekDays = moment.weekdaysShort();
//     return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
//       const date = this.getWeekDate(index);
//       if (date.isSameOrAfter(moment(), "day"))
//         return (
//           <p key={index} style={{ width: "13%" }}>
//             {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
//           </p>
//         );
//       return <p key={index} style={{ width: "13%" }}></p>;
//     });
//   };

//   showWeekBar = () => {
//     const { selectedWeek } = this.state;
//     return (
//       <div className="week-bar">
//         <p style={{ fontWeight: 700 }}>Content & Engagement Planner</p>
//         {[0, 1, 2, 3, 4].map((obj) => (
//           <button
//             key={obj}
//             className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
//             onClick={() => {
//               this.setState({ selectedWeek: obj }, this.getHotTopic);
//             }}
//           >
//             Week {obj + 1}
//           </button>
//         ))}
//       </div>
//     );
//   };

//   showHotTopic = () => {
//     const { current_hotTopic, brand_name } = this.state;
//     return (
//       <div className="hotTopic_row">
//         <div className="_header" style={{ backgroundColor: "#FEE17D" }}>
//           <img src={fireImg} />
//           <p>Hot Topic</p>
//         </div>
//         <div className="_content">
//           <div className="col-div" style={{ width: "50%" }}>
//             <p className="_title">{current_hotTopic.title}</p>
//             <p className="_description">{current_hotTopic.description}</p>
//           </div>
//           <div
//             className="_img"
//             style={{ backgroundImage: `url(${current_hotTopic.image_url})` }}
//           ></div>
//         </div>

//         <div className="col-div" style={{ height: "100%" }}>
//           <Link
//             to={{
//               pathname: `/hot-topic/${current_hotTopic.id}`,
//               state: {
//                 brand_name: brand_name,
//               },
//             }}
//             style={{ width: "100%" }}
//           >
//             <button className="btn btn-green" style={{ width: "100%" }}>
//               Edit hot topic
//             </button>
//           </Link>
//           <button
//             className="btn btn-pink"
//             style={{ width: "100%" }}
//             onClick={() => {
//               this.props.history.push("/hot-topic", {
//                 ...this.props.location.state,
//               });
//             }}
//           >
//             Manage hot topics
//           </button>
//         </div>
//       </div>
//     );
//   };
//   postOffer = async (data) => {
//     console.log("data", data);
//     const { retailer, attentionGrabber, postNow, scheduledDate, hot_topic } =
//       data;

//     const { brand_name } = this.state;
//     const offer = {
//       id: shortid.generate(),
//       retailer: retailer.value,
//       hot_topic: hot_topic,
//       attentionGrabber,
//       created_at: moment().valueOf(),
//       postNow,
//       scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
//     };
//     let res = await Firebase.addBrandOffer(brand_name, offer);

//     let schedule_data = {
//       id: res.id,
//       type: "offer",
//       time: scheduledDate.valueOf(),
//       brand_name: brand_name,
//     };
//     let schedule_res = await Firebase.registerSchedule(schedule_data);
//     console.log("schedule_res", schedule_res);

//     $("#add_offer_modal").modal("hide");
//   };

//   postPoll = async (data) => {
//     const { answers, question, quiz_img, postNow, scheduledDate, hot_topic } =
//       data;
//     console.log("data", data);
//     const { brand_name, brand } = this.state;

//     const isPostable =
//       question && quiz_img && !answers.find((answer) => !answer.text);

//     if (isPostable) {
//       let question_img = await Firebase.uploadImage(
//         quiz_img,
//         brand_name,
//         "polls"
//       );
//       const poll = {
//         id: shortid.generate(),
//         hot_topic,
//         answers,
//         question,
//         question_img,
//         created_at: moment().valueOf(),
//         postNow,
//         scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
//       };
//       Firebase.updateBrandDataById(brand, {
//         polls: [...this.state.polls, poll],
//       });
//       if (!postNow) {
//         let schedule_data = {
//           id: poll.id,
//           type: "poll",
//           time: poll.scheduledDate,
//           brand_name: brand_name,
//           brand_id: brand,
//         };
//         let schedule_res = await Firebase.registerSchedule(schedule_data);
//         console.log("schedule_res", schedule_res);
//       }
//       $("#add_poll_modal").modal("hide");
//     } else {
//       alert("please fill all required fields");
//       return "empty_fields";
//     }
//   };
//   /*
//   All func related to posting feed
//   */
//   handlePost = async (postData) => {
//     const {
//       content_type,
//       content,
//       title,
//       postNow,
//       scheduledDate,
//       event,
//       product,
//     } = postData;
//     const { brand_name, username } = this.state;
//     let folder = "posters/" + brand_name;

//     postData.uid = localStorage.getItem("uid");
//     postData.username = username;
//     postData.scheduledDate = postNow
//       ? moment().valueOf()
//       : scheduledDate.valueOf();
//     postData.event_tag = event && event.id;
//     postData.product_tag = product && product.id;
//     this.setState({ postData }, () =>
//       this.upload(content_type, content, title, folder)
//     );
//   };
//   handleUploadProgress = (snapshot) => {
//     var progress = (
//       (snapshot.bytesTransferred / snapshot.totalBytes) *
//       100
//     ).toFixed(0);
//     this.setState({ loading_script: UPLOADING_VIDEO + " " + progress + "%" });
//   };

//   handleUploadError = (error) => {
//     this.setState({ loading: false, loading_script: "" });
//   };

//   handleDownloadURL = () => {
//     const { uploadTask } = this.state;
//     uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
//       this.setState({ loading: false, loading_script: "" });
//       this.postFeed(downloadURL);
//     });
//   };
//   upload = async (content_type, content, title, uploadFolder) => {
//     if (content_type === IMAGE_UPLOAD) {
//       this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
//       let img_url = await Firebase.uploadImage(
//         content,
//         title,
//         uploadFolder + "/images"
//       );
//       this.setState({ loading: false });
//       this.postFeed(img_url);
//     } else if (content_type === VIDEO_UPLOAD) {
//       const uploadTask = Firebase.uploadVideo(
//         content,
//         uploadFolder + "/videos"
//       );
//       this.setState({
//         uploadTask,
//         loading: true,
//         loading_script: UPLOADING_VIDEO,
//       });
//       uploadTask.on(
//         "state_changed",
//         this.handleUploadProgress,
//         this.handleUploadError,
//         this.handleDownloadURL
//       );
//     } else if (content_type === YOUTUBE_URL) {
//       this.postFeed(content);
//     }
//   };
//   postFeed = async (downloadUrl) => {
//     const { postData, brand_name } = this.state;
//     const {
//       postNow,
//       content_type,
//       scheduledDate,
//       description,
//       event_tag,
//       hot_topic,
//       product_tag,
//       title,
//       type,
//       uid,
//       topic,
//       username,
//     } = postData;
//     const poster = {
//       title,
//       type,
//       topic,
//       media_type: content_type,
//       media_url: downloadUrl,
//       content: description,
//       hot_topic,
//       event_tag,
//       product_tag,
//       uid,
//       username,
//       postNow,
//       scheduledDate,
//     };
//     let res = await Firebase.addPost(poster, brand_name);
//     if (!postNow) {
//       let schedule_data = {
//         id: res.id,
//         type: "feed",
//         time: scheduledDate.valueOf(),
//         brand_name: brand_name,
//       };
//       await Firebase.registerSchedule(schedule_data);
//     }
//   };

//   postCompetition = async (
//     title,
//     image_content,
//     content,
//     task,
//     postNow,
//     scheduledDate,
//     runUntil,
//     hot_topic
//   ) => {
//     const { brand_name, username } = this.state;
//     let folder = "posters/" + brand_name;
//     let image_url = await Firebase.uploadImage(
//       image_content,
//       `competition_${moment().valueOf()}`,
//       folder
//     );

//     // let avatar_url= "https://img.icons8.com/clouds/2x/user.png";
//     let avatar_url = "";

//     let post = {
//       title,
//       image_url,
//       uid: localStorage.getItem("uid"),
//       content,
//       username,
//       avatar_url,
//       task,
//       postNow,
//       scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
//       runUntil: runUntil.valueOf(),
//       hot_topic,
//     };
//     let res = await Firebase.addCompetition(post, brand_name);
//     if (!postNow) {
//       let schedule_data = {
//         id: res.id,
//         type: "competition",
//         time: scheduledDate.valueOf(),
//         brand_name: brand_name,
//       };
//       let schedule_res = await Firebase.registerSchedule(schedule_data);
//       console.log("schedule_res", schedule_res);
//     }
//   };
//   createEvent = async (payload) => {
//     const {
//       img_content,
//       title,
//       address,
//       token,
//       type,
//       description,
//       selectedDate,
//     } = payload;
//     let { brand_name } = this.state;
//     let folder = "events/" + brand_name;
//     this.setState({ loading: true });
//     let image_url = await Firebase.uploadImage(img_content, title, folder);
//     let event = {
//       title,
//       type,
//       address,
//       description,
//       image_url,
//       token,
//       time: selectedDate.toDate(),
//     };

//     Firebase.addEvent(event, brand_name).then((res) => {
//       this.setState({ loading: false });
//     });
//   };
//   renderNewPollDialog = (brand_name) => (
//     <div
//       className="modal fade"
//       id="add_poll_modal"
//       tabIndex="-1"
//       role="dialog"
//       aria-labelledby="modal-default-fadein"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog add-new-poll-modal" role="document">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">Add a new poll</h5>
//             <button
//               type="button"
//               className="close"
//               data-dismiss="modal"
//               aria-label="Close"
//             >
//               <span aria-hidden="true">&times;</span>
//             </button>
//           </div>
//           <div className="modal-body pb-1">
//             <NewPoll
//               selectedDate={this.state.selectedDate}
//               brand_name={brand_name}
//               onAdd={this.postPoll}
//             />
//           </div>
//           <div className="modal-footer"></div>
//         </div>
//       </div>
//     </div>
//   );

//   renderNewOfferDialog = (brand_name) => (
//     <div
//       className="modal fade"
//       id="add_offer_modal"
//       tabIndex="-1"
//       role="dialog"
//       aria-labelledby="modal-default-fadein"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog add-new-offer-modal" role="document">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title">Schedule an offer</h5>
//             <button
//               type="button"
//               className="close"
//               data-dismiss="modal"
//               aria-label="Close"
//             >
//               <span aria-hidden="true">&times;</span>
//             </button>
//           </div>
//           <div className="modal-body pb-1">
//             <NewOffer
//               selectedDate={this.state.selectedDate}
//               brand_name={brand_name}
//               retailers={this.state.retailers}
//               onAdd={this.postOffer}
//             />
//           </div>
//           <div className="modal-footer"></div>
//         </div>
//       </div>
//     </div>
//   );

//   render() {
//     const {
//       username,
//       role,
//       logo,
//       brand,
//       is_property_brand,
//       loading,
//       loading_script,
//       brand_name,
//       current_hotTopic,
//       territory,
//     } = this.state;
//     return (
//       <div id="page-container">
//         <Header
//           username={username}
//           role={role}
//           onHome={this.goBack}
//           logo={logo}
//           brand={brand}
//           brandName={brand_name}
//           is_property_brand={is_property_brand}
//         />
//         <main id="main-container" className="super-planner-content">
//           {loading && (
//             <div className="loading">
//               <i className="fa fa-4x fa-sync fa-spin text-muted" />
//               <p>{loading_script}</p>
//             </div>
//           )}
//           {this.showWeekBar()}
//           {current_hotTopic && this.showHotTopic()}
//           <div className="calendar">
//             <div className="date">
//               <p style={{ width: "9%" }}>Content</p>
//               {this.showDays()}
//             </div>
//             <div className="plan_row">
//               <div
//                 className="plan_header"
//                 style={{ backgroundColor: "#ffcfff" }}
//               >
//                 <img src={feedsImg} />
//                 <p>Feeds</p>
//               </div>
//               {this.showPlans("feed")}
//             </div>
//             <div className="plan_row">
//               <div
//                 className="plan_header"
//                 style={{ backgroundColor: "#d5ffc6" }}
//               >
//                 <img src={pollsImg} />
//                 <p>Polls</p>
//               </div>
//               {this.showPlans("poll")}
//             </div>
//             <div className="plan_row">
//               <div
//                 className="plan_header"
//                 style={{ backgroundColor: "#FAFF87" }}
//               >
//                 <img src={offerImg} />
//                 <p>Offer</p>
//               </div>
//               {this.showPlans("offer")}
//             </div>
//             <div className="plan_row">
//               <div
//                 className="plan_header"
//                 style={{ backgroundColor: "#daf6ff" }}
//               >
//                 <img src={gameImg} />
//                 <p>Games</p>
//               </div>
//               {this.showPlans("competition")}
//             </div>
//             <div className="plan_row">
//               <div
//                 className="plan_header"
//                 style={{ backgroundColor: "#C7B1FF" }}
//               >
//                 <img src={eventImg} />
//                 <p>Events</p>
//               </div>
//               {this.showPlans("event")}
//             </div>
//           </div>
//           {this.renderNewPollDialog(brand_name)}
//           {this.renderNewOfferDialog(brand_name)}
//           <AddPost
//             selectedDate={this.state.selectedDate}
//             brand_name={brand_name}
//             onAdd={this.handlePost}
//           />
//           <AddCompetiton
//             selectedDate={this.state.selectedDate}
//             brand_name={brand_name}
//             onAdd={this.postCompetition}
//           />
//           <AddEventModal
//             selectedDate={this.state.selectedDate}
//             createEvent={this.createEvent}
//             territory={territory}
//           />
//         </main>
//       </div>
//     );
//   }
// }
// function mapDispatchToProps(dispatch) {
//   return {
//     dispatch,
//   };
// }
// function mapStateToProps(state) {
//   return {
//     uid: state.uid,
//     users: state.users,
//     unreads: state.unreads,
//   };
// }
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(SuperContentPlanner);

const SuperContentPlanner = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [role, setRole] = useState(0);
  const [username, setUserName] = useState("");
  const [loading_script, setLoadingScript] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [posts, setPosts] = useState([]);
  const [polls, setPolls] = useState([]);
  const [events, setEvents] = useState([]);
  const [competitions, setCompetitions] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [offers, setOffers] = useState([]);
  const [postData, setPostData] = useState(null);
  const superContents = useSelector(SuperContentSelector);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { role, username } = location.state;
      setRole(role);
      setUserName(username);
      Firebase.getSuperContents((superContents) => {
        dispatch(saveSuperContents(superContents));
        setLoading(false);
      });
    }
  }, [location]);

  useEffect(() => {
    if (superContents) {
      const { feed, offer, competition, poll } = superContents;
      if (feed) {
        const posts = Object.keys(feed).map((id) => {
          return { ...feed[id], id: id };
        });
        setPosts(posts);
      }
    }
  }, [superContents]);

  useEffect(() => {
    console.log("posts", posts);
  }, [posts]);

  const getWeekDate = (i) => {
    if (moment().isSame(moment().startOf("week"))) {
      return moment().add("days", selectedWeek * 7 + i - 6);
    }
    return moment()
      .startOf("week")
      .add("days", selectedWeek * 7 + i + 1);
  };
  const showDays = () => {
    const weekDays = moment.weekdaysShort();
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = getWeekDate(index);
      if (date.isSameOrAfter(moment(), "day"))
        return (
          <p key={index} style={{ width: "13%" }}>
            {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
          </p>
        );
      return <p key={index} style={{ width: "13%" }}></p>;
    });
  };
  const showWeekBar = () => {
    return (
      <div className="week-bar">
        <p style={{ fontWeight: 700 }}>Content & Engagement Planner</p>
        {[0, 1, 2, 3, 4].map((obj) => (
          <button
            key={obj}
            className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
            onClick={() => {
              setSelectedWeek(obj);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
    );
  };
  const showPlans = (type = "feed") => {
    let PlanItem = ({ date }) => {
      let image = null,
        youtube_video = null,
        video = null;
      if (type === "feed") {
        const post = posts.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image =
          post &&
          (post.media_type === IMAGE_UPLOAD || post.media_type === GIF_UPLOAD)
            ? post.media_url
            : null;
        youtube_video =
          post && post.media_type === YOUTUBE_URL ? post.media_url : null;
        video =
          post && post.media_type === VIDEO_UPLOAD ? post.media_url : null;
      } else if (type === "poll") {
        const poll = polls.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image = poll ? poll.question_img : null;
      } else if (type === "competition") {
        const competition = competitions.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        image = competition ? competition.img_url : null;
      } else if (type === "offer") {
        const offer = offers.find((obj) =>
          date.isSame(new Date(obj.scheduledDate), "day")
        );
        const retailer = retailers.find(
          (obj) => offer && obj.retailerName === offer.retailer
        );
        image = retailer ? retailer.logo : null;
      } else if (type === "event") {
        const event = events.find((obj) =>
          date.isSame(obj.time.toDate(), "day")
        );
        image = event ? event.image_url : null;
      }
      if (image) {
        return (
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="calendar-item"
          >
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (video) {
        return (
          <div className="calendar-item">
            <ReactPlayer
              url={video}
              width="100%"
              height="100%"
              controls={true}
            />
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      if (youtube_video) {
        return (
          <div className="calendar-item">
            <iframe
              title="video"
              width="100%"
              height="100%"
              src={`//www.youtube.com/embed/${getYoutubeId(
                youtube_video
              )}?modestbranding=1&showinfo=0`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      const isPastDay = date.isBefore(moment(), "day");
      return (
        <button
          className="add-plan-btn"
          type="button"
          data-toggle="modal"
          data-target={`#add_${type}_modal`}
          onClick={() => {
            setSelectedDate(date);
          }}
          disabled={isPastDay}
        >
          {!isPastDay && (
            <img src={plugImg} className="default-item" alt="default" />
          )}
        </button>
      );
    };

    return [0, 1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="plan">
        <PlanItem date={getWeekDate(i)} />
      </div>
    ));
  };
  const createEvent = async (payload) => {
    const {
      img_content,
      title,
      address,
      token,
      type,
      description,
      selectedDate,
    } = payload;
    let { brand_name } = this.state;
    let folder = "events/" + brand_name;
    setLoading(true);
    let image_url = await Firebase.uploadImage(img_content, title, folder);
    let event = {
      title,
      type,
      address,
      description,
      image_url,
      token,
      time: selectedDate.toDate(),
    };

    Firebase.addEvent(event, brand_name).then((res) => {
      setLoading(false);
    });
  };

  const postFeed = async (downloadUrl) => {
    const {
      postNow,
      content_type,
      scheduledDate,
      description,
      event_tag,
      article_tag,
      product_tag,
      title,
      type,
      uid,
      topic,
      username,
    } = postData;
    const poster = {
      title,
      type,
      topic,
      media_type: content_type,
      media_url: downloadUrl,
      content: description,
      event_tag: event_tag || null,
      article_tag: article_tag || null,
      product_tag: product_tag || null,
      uid,
      username,
      postNow,
      scheduledDate,
    };
    await Firebase.addSuperFeed(poster);
    setPostData(null);
  };
  const handlePost = async (postData) => {
    const { postNow, scheduledDate } = postData;
    const uid = localStorage.getItem("uid");
    await Firebase.addSuperFeed({
      ...postData,
      uid,
      username,
      scheduledDate: scheduledDate.valueOf(),
    });
  };
  const postPoll = () => {};

  const renderNewPollDialog = () => (
    <div
      className="modal fade"
      id="add_poll_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog add-new-poll-modal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a new poll</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <NewPoll selectedDate={selectedDate} onAdd={postPoll} />
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
  return (
    <div id="page-container">
      <Header username={username} role={role} />
      <main id="main-container" className="super-planner-content">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
            <p>{loading_script}</p>
          </div>
        )}
        {showWeekBar()}
        <div className="calendar">
          <div className="date">
            <p style={{ width: "9%" }}>Content</p>
            {showDays()}
          </div>
          <div className="plan_row">
            <div className="plan_header" style={{ backgroundColor: "#ffcfff" }}>
              <img src={feedsImg} alt="feed" />
              <p>Feeds</p>
            </div>
            {showPlans("feed")}
          </div>
          <div className="plan_row">
            <div className="plan_header" style={{ backgroundColor: "#d5ffc6" }}>
              <img src={pollsImg} alt="polls" />
              <p>Polls</p>
            </div>
            {showPlans("poll")}
          </div>
          <div className="plan_row">
            <div className="plan_header" style={{ backgroundColor: "#FAFF87" }}>
              <img src={offerImg} alt="offer" />
              <p>Offer</p>
            </div>
            {showPlans("offer")}
          </div>
          <div className="plan_row">
            <div className="plan_header" style={{ backgroundColor: "#daf6ff" }}>
              <img src={gameImg} alt="games" />
              <p>Games</p>
            </div>
            {showPlans("competition")}
          </div>
          <div className="plan_row">
            <div className="plan_header" style={{ backgroundColor: "#C7B1FF" }}>
              <img src={eventImg} alt="events" />
              <p>Events</p>
            </div>
            {showPlans("event")}
          </div>
        </div>
        {renderNewPollDialog()}
        {/* {this.renderNewOfferDialog()} */}
        <AddPost selectedDate={selectedDate} onAdd={handlePost} />
        <AddCompetiton
          selectedDate={selectedDate}
          // brand_name={brand_name}
          onAdd={() => {}}
        />
        <AddEventModal
          selectedDate={selectedDate}
          createEvent={createEvent}
          // territory={territory}
        />
      </main>
    </div>
  );
};

export default SuperContentPlanner;



// WEBPACK FOOTER //
// ./src/screens/SuperContentPlanner/index.js